export const FETCH_TABLE_DATA_SUCCESS = "FETCH_TABLE_DATA_SUCCESS";
export const FETCH_TABLE_DATA_ERROR = "FETCH_TABLE_DATA_ERROR";

export const FETCH_TABLE_DATA_SEARCH_SUCCESS =
  "FETCH_TABLE_DATA_SEARCH_SUCCESS";

export const UPDATE_TABLE_DATA_SUCCESS = "UPDATE_TABLE_DATA_SUCCESS";
export const UPDATE_TABLE_DATA_ERROR = "UPDATE_TABLE_DATA_ERROR";

export const INSERT_TABLE_DATA_SUCCESS = "INSERT_TABLE_DATA_SUCCESS";
export const INSERT_TABLE_DATA_ERROR = "INSERT_TABLE_DATA_ERROR";

export const DELETE_TABLE_DATA_SUCCESS = "DELETE_TABLE_DATA_SUCCESS";
export const DELETE_TABLE_DATA_ERROR = "DELETE_TABLE_DATA_ERROR";

export const SET_MANAGGE_DATA_REDUCER = "SET_MANAGGE_DATA_REDUCER";

export const FETCH_ROLE_TABLE_SUCCESS = "FETCH_ROLE_TABLE_SUCCESS";
export const FETCH_ROLE_TABLE_ERROR = "FETCH_ROLE_TABLE_ERROR";

export const FETCH_PERMISSION_TABLE_SUCCESS = "FETCH_PERMISSION_TABLE_SUCCESS";
export const FETCH_PERMISSION_TABLE_ERROR = "FETCH_PERMISSION_TABLE_ERROR";

export const FETCH_ROLE_PERMISSION_TABLE_SUCCESS =
  "FETCH_ROLE_PERMISSION_TABLE_SUCCESS";
export const FETCH_ROLE_PERMISSION_TABLE_ERROR =
  "FETCH_ROLE_PERMISSION_TABLE_ERROR";

export const FETCH_PERMISSION_SEARCH_SUCCESS =
  "FETCH_PERMISSION_SEARCH_SUCCESS";

export const FETCH_USER_PERMISSION_TABLE_SUCCESS =
  "FETCH_USER_PERMISSION_TABLE_SUCCESS";
export const FETCH_USER_PERMISSION_TABLE_ERROR =
  "FETCH_USER_PERMISSION_TABLE_ERROR";

export const MASTERDATA_INSERT_JSON_SUCCESS = "MASTERDATA_INSERT_JSON_SUCCESS";
export const MASTERDATA_INSERT_JSON_ERROR = "MASTERDATA_INSERT_JSON_ERROR";
